import { PropsWithChildren, useRef } from 'react'

import { useCreation } from 'ahooks'

import { AuctionDetailAuthenticatorRef } from '../Core/interface'

import { AuctionDetailAuthenticatorStoreCotnext } from './context/StoreContext'
import { createAuctionDetailAuthenticatorStore } from './store/createStore'

export const AuctionDetailAuthenticatorStoreProvider = ({
  children
}: PropsWithChildren) => {
  const ref = useRef<AuctionDetailAuthenticatorRef>(null)
  const store = useCreation(
    () => createAuctionDetailAuthenticatorStore({ ref }),
    []
  )
  return (
    <AuctionDetailAuthenticatorStoreCotnext value={store}>
      {children}
    </AuctionDetailAuthenticatorStoreCotnext>
  )
}
